import { all, select, takeEvery, fork, put, call } from 'redux-saga/effects'

// action
import { shopActions, paymentActions } from '@redux/store/index'

// lib
import { Logger } from '@utils'
import config from '@configs'

// api
import { seasonProductApi, ResType } from '@api'

// schemas
import {
	SeasonProduct,
	SeasonProductType,
	ProductOption,
	ProductOptionType,
} from '@schemas'

const apiGetSeasonProduct = async (params: {
	seasonId: string
	accessToken: string
}): Promise<ResType | undefined> => {
	const res: ResType | undefined = await seasonProductApi.getShopSeasonProduct({
		query: { seasonId: params.seasonId },
	})
	return res
}

const apiGetSeasonProductDetail = async (params: {
	sessionProductId: string
}): Promise<ResType | undefined> => {
	const res: ResType | undefined = await seasonProductApi.getShopSeasonProductDetail({
		params: { sessionProductId: params.sessionProductId },
	})
	return res
}

function* triggerInitShopPageSaga() {
	try {
		const seasonProductList: SeasonProductType[] = yield select(
			state => state.shop.productList,
		)
		const shopConfig = config.get('shop')
		const seasonId: string = shopConfig.seasonId
		const sessionAccessToken: string = sessionStorage.getItem('accessCustomerToken') ?? ''

		if (seasonProductList.length === 0) {
			yield put(shopActions.PRODUCT_LIST_STATUS('loading'))
		}

		const apiRes: ResType = yield call(apiGetSeasonProduct, {
			seasonId: seasonId,
			accessToken: sessionAccessToken,
		})

		if (apiRes.status === 200) {
			const data = apiRes.data[0].productList as any[]
			const newSeaonsProductList: SeasonProductType[] = data.map(
				aData => new SeasonProduct(aData),
			)

			yield put(shopActions.PRODUCT_LIST(newSeaonsProductList))

			if (newSeaonsProductList.length > 0) {
				yield put(shopActions.PRODUCT_LIST_STATUS('ok'))
			} else {
				yield put(shopActions.PRODUCT_LIST_STATUS('empty'))
			}
		} else {
			yield put(shopActions.PRODUCT_LIST_STATUS('empty'))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* triggerInitShopItemPageSaga() {
	try {
		const seasonProductList: SeasonProductType[] = yield select(
			state => state.shop.productList,
		)
		const shopConfig = config.get('shop')
		const seasonId: string = shopConfig.seasonId
		const sessionAccessToken: string = sessionStorage.getItem('accessCustomerToken') ?? ''

		if (seasonProductList.length === 0) {
			yield put(shopActions.SHOP_ITEM_STATUS('loading'))
		}

		const apiRes: ResType = yield call(apiGetSeasonProduct, {
			seasonId: seasonId,
			accessToken: sessionAccessToken,
		})

		if (apiRes.status === 200) {
			const data = apiRes.data[0].productList as any[]
			const newSeaonsProductList: SeasonProductType[] = data.map(
				aData => new SeasonProduct(aData),
			)

			yield put(shopActions.PRODUCT_LIST(newSeaonsProductList))

			if (newSeaonsProductList.length > 0) {
				yield put(shopActions.SHOP_ITEM_STATUS('ok'))
			} else {
				yield put(shopActions.SHOP_ITEM_STATUS('empty'))
			}
		} else {
			yield put(shopActions.SHOP_ITEM_STATUS('empty'))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* getShopItemOption() {
	try {
		const seasonProductList: SeasonProductType[] = yield select(
			state => state.shop.productList,
		)
		const productCode: string = yield select(state => state.shop.getShopItemOption)

		const filteredProduct = seasonProductList.filter(
			anItem => anItem.productCode === productCode.toUpperCase(),
		)

		if (filteredProduct.length === 0) return

		const sessionProductId = filteredProduct[0].productId
		const apiRes: ResType = yield call(apiGetSeasonProductDetail, {
			sessionProductId: sessionProductId,
		})

		if (apiRes.status === 200) {
			const data = apiRes.data as any[]
			const optionList: ProductOptionType[] = data.map(aData => new ProductOption(aData))

			yield put(shopActions.OPTION_LIST(optionList))
		} else {
			yield put(shopActions.OPTION_LIST([]))
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(shopActions.TRIGGER_INIT_SHOP_PAGE, triggerInitShopPageSaga)
	yield takeEvery(shopActions.TRIGGER_INIT_SHOP_ITEM_PAGE, triggerInitShopItemPageSaga)
	yield takeEvery(shopActions.GET_SHOP_ITEM_OPTION, getShopItemOption)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
